import React from 'react';
import Modal from 'react-bootstrap/Modal';
import PropTypes from 'prop-types';
import { toast } from 'react-toastify';
import { BeatLoader } from 'react-spinners';
import 'braintree-web';
import DropIn from 'braintree-web-drop-in-react';
import paymentService from '../../../services/paymentService';
import profileService from '../../../services/profileService';

export default class AddMinutes extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            minutes: [],
            clientToken: null,
            nonce: '',
            minuteId: '',
            submited: true
        }
        this.handleChange = this.handleChange.bind(this);
        this.handleNounce = this.handleNounce.bind(this);
    }

    componentDidMount() {
        this.loadMinutes();
        this.generateBrainTreeToken()
    }

    generateBrainTreeToken() {
        paymentService.generateToken().then(response => {
            this.setState({ clientToken: response });
        }).catch(error => {
            toast.error(error.response, this.options)
        })
    }

    loadMinutes() {
        profileService.getExtraMinutePackages()
            .then(result => {
                this.setState({ minutes: result });
            })
            .catch(error => {
            });
    }

    handleChange = event => {
        const { name, value } = event.target;
        this.setState({
            [name]: value,
            error: null
        });
    }

    validateForm() {
        return this.state.minuteId
    }

    async handleNounce() {
        if (this.validateForm()) {
            const { nonce } = await this.instance.requestPaymentMethod();
            this.setState({
                nonce: nonce
            })
            await this.callSubmit(this.state)
        } else {
            this.setState({ error: "Pricing plan is required!" })
        }
    }

    async callSubmit(data) {
        this.setState({
            submited: false,
            loading: true
        })
        let payment = await this.props.handleSubmitMinute(this.state);
        if (payment) {
            this.setState({
                loading: false
            })
        }
    }


    render() {
        const { minutes, clientToken, minuteId, error, submited } = this.state
        return (
            <div>
                <Modal show={this.props.show} onHide={this.props.handleClose}>
                    <Modal.Header closeButton>
                        <Modal.Title>Add call credits</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <form className="form-wrapper">
                            <table className="table mb-0 tb-list-groups">
                                <thead className="lightblue-bg">
                                    <tr>
                                        <th className="border-0"> # </th>
                                        <th className="border-0">Price</th>
                                        <th className="border-0">Call credits </th>
                                        <th className="border-0 text-center"> </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {minutes.map((minute, i) =>
                                        <tr key={i}>
                                            <td>{i + 1}</td>
                                            <td><span>$</span>{minute.price}</td>
                                            <td>{minute.minutes}</td>
                                            <td >
                                                <div className="custom-radio-container">
                                                    <input type="radio"
                                                        id={`sel-${minute._id}`}
                                                        className="custom-radio"
                                                        name="minuteId"
                                                        value={minute._id}
                                                        onChange={this.handleChange} />
                                                    <label htmlFor={`sel-${minute._id}`}></label>
                                                    <div className="check"><div className="inside"></div></div>
                                                </div>

                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                            {error &&
                                <div className={'alert alert-danger'}>{error}</div>
                            }
                        </form>
                        {this.state.loading ?
                            <div className=" m-5 text-center">
                                <BeatLoader
                                    // css={override}
                                    sizeUnit={"px"}
                                    size={15}
                                    color={'#299bff'}
                                    loading={this.state.loading}
                                />
                            </div> : null}
                        {clientToken && minuteId ?
                            <div>
                                {submited ?
                                    <div>
                                        <DropIn
                                            options={{ authorization: this.state.clientToken }}
                                            onInstance={instance => (this.instance = instance)}
                                        />
                                    </div> : null}

                            </div> : null}
                        {submited ?
                            <div>
                                <DropIn
                                    options={{ authorization: this.state.clientToken }}
                                    onInstance={instance => (this.instance = instance)}
                                />
                            </div> : null}
                    </Modal.Body>
                    <Modal.Footer>
                        {clientToken && minuteId ? <button className="btn btn-lightblue" onClick={this.handleNounce}>
                            Save
                </button> : null}
                        <button className="btn btn-lightblue" onClick={this.props.handleClose}>
                            Close
                </button>

                    </Modal.Footer>
                </Modal>
            </div>
        );
    }
}

AddMinutes.propTypes = {
    handleSubmitMinute: PropTypes.func,
    handleClose: PropTypes.func,
    show: PropTypes.bool
}


// WEBPACK FOOTER //
// ./src/components/planComponent/modals/addMinutes.js